import { createClient } from '@supabase/supabase-js';

// Supabase project configuration.
// You can override these with Vite env vars locally if you prefer:
//   VITE_SUPABASE_URL
//   VITE_SUPABASE_ANON_KEY
//
// Fallbacks below are taken from the API key you provided.

const fallbackUrl = 'https://iyxgagvqmlcdeledwgtd.supabase.co';
const fallbackAnonKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml5eGdhZ3ZxbWxjZGVsZWR3Z3RkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU5NzAyNDcsImV4cCI6MjA4MTU0NjI0N30.ZMXe1f0CWKvxOYTs4Kupb2nORKAYltcsjQvaww9K4SU';

// Safely get environment variables with fallbacks
const supabaseUrl = (import.meta as any).env?.VITE_SUPABASE_URL || fallbackUrl;
const supabaseAnonKey = (import.meta as any).env?.VITE_SUPABASE_ANON_KEY || fallbackAnonKey;

// Ensure we always have valid values
if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('[Supabase] Missing configuration. Using fallback values.');
}

// Create client with error handling
let supabase;
try {
  supabase = createClient(supabaseUrl, supabaseAnonKey);
} catch (error) {
  console.error('[Supabase] Failed to create client:', error);
  // Create a mock client that won't crash the app
  supabase = {
    auth: {
      getSession: () => Promise.resolve({ data: { session: null }, error: null }),
      onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } }),
      signInWithPassword: () => Promise.resolve({ data: null, error: { message: 'Supabase not initialized' } })
    }
  } as any;
}

export { supabase };

